import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { AlertBanner } from './AlertBanner';
import { getGeneralizedErrors } from './helpers';
import type { IValidationError, IValidationResult } from './types';
import './ValidationAlert.scss';
export interface IValidationErrorWithElements extends IValidationError {
  validationElements?: ReactElement;
}
export interface IValidationAlert {
  defaultHeading?: string;
  validationError: IValidationErrorWithElements;
}

/**
 * displays section level validation error block
 */
export function ValidationAlert(t0) {
  const $ = _c(3);
  const {
    validationError,
    defaultHeading
  } = t0;
  const heading = validationError.heading || defaultHeading;
  let t1;
  if ($[0] !== heading || $[1] !== validationError) {
    t1 = validationError ? <AlertBanner iconName="exclamation-circle-fill" header={heading}>{validationError.field && `[${validationError.field}]`}{validationError.message}{validationError.validationElements}</AlertBanner> : null;
    $[0] = heading;
    $[1] = validationError;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export type ValidationResult = {
  validation: IValidationResult;
  validationErrors?: never;
};
export type ValidationErrors = {
  validation?: never;
  validationErrors: IValidationErrorWithElements[];
};
export type ValidationAlertsProps = {
  defaultHeading?: string;
} & (ValidationResult | ValidationErrors);
export function ValidationAlerts({
  defaultHeading,
  validation: validationResult,
  validationErrors
}: ValidationAlertsProps): ReactElement[] {
  const errors = validationResult ? getGeneralizedErrors(validationResult) : validationErrors;
  return errors?.filter(err => !err.isHidden).map(err => <ValidationAlert key={`alert|${err.code}|${err.field}|${err.heading}|${err.message}`} validationError={err} defaultHeading={err.hideDefaultHeader ? '' : defaultHeading} />);
}